"use client";

import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { useEffect, useRef, useState } from "react";
export default function YourComprehensiveTransportationSolutions() {
  const {
    ref: cardRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.3
  });
  const heroRef = useRef<HTMLDivElement>(null);
  const [parallaxOffset, setParallaxOffset] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (!isPaused && heroRef.current) {
        const rect = heroRef.current.getBoundingClientRect();
        const scrolled = window.scrollY;
        const offset = scrolled * 0.5;
        setParallaxOffset(offset);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [isPaused]);
  return <section ref={heroRef} className="relative w-full h-screen overflow-hidden bg-background">
      {}
      <div className="absolute inset-0 bg-cover bg-center transition-transform duration-[var(--duration-slow)] ease-[var(--ease-smooth)]" style={{
      backgroundImage: "url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1431253/img/luxury_sedan_sunrise_highway.png)",
      transform: `translateY(${parallaxOffset}px)`
    }} />

      {}
      <div className="absolute inset-0 bg-gradient-to-t from-background/80 via-background/40 to-transparent" />

      {}
      <div className="relative z-10 h-full flex items-end justify-center px-4 pb-16 md:pb-24">
        <Card ref={cardRef} onMouseEnter={() => setIsPaused(true)} onMouseLeave={() => setIsPaused(false)} className={`
            glass-effect max-w-3xl w-full
            transition-all duration-[var(--duration-slow)] ease-[var(--ease-out-back)]
            hover:shadow-strong hover:-translate-y-2
            ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}
          `}>
          <CardContent className="space-y-6 p-8 md:p-10">
            <h1 className="text-3xl md:text-5xl font-display font-bold text-foreground leading-tight">
              Your Comprehensive Transportation Solutions
            </h1>
            
            <p className="text-lg md:text-xl text-foreground/90 leading-relaxed">
              Experience premium car service across Connecticut, New York City, Long Island, and New Jersey. 
              We specialize in airport transfers, city-to-city rides, corporate travel, and event transportation 
              with our fleet of luxury sedans and SUVs. Available 24/7 for your convenience.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 pt-2">
              <Link to="/ServicesPage">
                <Button size="lg" className="w-full sm:w-auto transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] hover:scale-105">
                  <span className="relative z-10">Explore Services</span>
                </Button>
              </Link>

              <Link to="/FleetPage">
                <Button size="lg" variant="outline" className="hover-lift w-full sm:w-auto">
                  View Our Fleet
                </Button>
              </Link>
            </div>

            {}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 pt-6 border-t border-muted/20">
              <div className="text-center">
                <p className="text-2xl font-bold text-accent">24/7</p>
                <p className="text-sm text-foreground/80">Availability</p>
              </div>
              <div className="text-center">
                <p className="text-2xl font-bold text-accent">6</p>
                <p className="text-sm text-foreground/80">Major Airports</p>
              </div>
              <div className="text-center">
                <p className="text-2xl font-bold text-accent">4</p>
                <p className="text-sm text-foreground/80">Service Areas</p>
              </div>
              <div className="text-center">
                <p className="text-2xl font-bold text-accent">Premium</p>
                <p className="text-sm text-foreground/80">Fleet</p>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </section>;
}